import { ArrowLeft, ArrowRight, Save, Download, Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

interface ActionBarProps {
  mode: 'create' | 'edit' | 'clone';
  canGoPrev: boolean;
  canGoNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  onSave: () => void;
  onExport: () => void;
  onClone?: () => void;
  isSaving: boolean;
  isCloning?: boolean;
}

export function ActionBar({
  mode,
  canGoPrev,
  canGoNext,
  onPrev,
  onNext,
  onSave,
  onExport,
  onClone,
  isSaving,
  isCloning
}: ActionBarProps) {
  return (
    <div className="sticky bottom-0 z-10 bg-background pt-4 pb-6 border-t border-border mt-8">
      <Card className="shadow-lg">
        <div className="p-4">
          <div className="flex items-center justify-between gap-4">
            {/* Left: Navigation */}
            <div className="flex items-center gap-2">
              <Button
                variant="outline"
                onClick={onPrev}
                disabled={!canGoPrev}
                data-testid="button-prev-step"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Previous
              </Button>
              <Button
                variant="outline"
                onClick={onNext}
                disabled={!canGoNext}
                data-testid="button-next-step"
              >
                Next
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </div>

            {/* Right: Actions */}
            <div className="flex items-center gap-2">
              <Button 
                variant="outline" 
                onClick={onExport}
                data-testid="button-export"
              >
                <Download className="w-4 h-4 mr-2" />
                Export JSON
              </Button>
              {mode === 'clone' && onClone && (
                <Button 
                  onClick={onClone}
                  disabled={isCloning}
                  data-testid="button-clone"
                >
                  <Copy className="w-4 h-4 mr-2" />
                  Clone Template
                </Button>
              )}
              <Button 
                onClick={onSave}
                disabled={isSaving}
                data-testid="button-save"
              >
                <Save className="w-4 h-4 mr-2" />
                {isSaving ? 'Saving...' : 'Save Template'}
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
